import img1 from "../images/blog/news-01.jpg";
import img2 from "../images/blog/news-02.jpg";
import img3 from "../images/blog/news-03.jpg";
import img4 from "../images/blog/image-15.jpg";
import img5 from "../images/blog/image-16.jpg";
import img6 from "../images/blog/image-17.jpg";
import img7 from "../images/blog/image-18.jpg";
import img8 from "../images/blog/image-19.jpg";
import img9 from "../images/blog/image-20.jpg";
import img10 from "../images/blog/image-21.jpg";
import img11 from "../images/blog/image-22.jpg";
import img12 from "../images/blog/image-23.jpg";
import img13 from "../images/blog/image-06.jpg";
import img14 from "../images/blog/image-09.jpg";
import img15 from "../images/blog/image-12.jpg";
import img16 from "../images/blog/image-07.jpg";
import img17 from "../images/blog/image-10.jpg";
import img18 from "../images/blog/image-11.jpg";
import img19 from "../images/blog/image-13.jpg";
import img20 from "../images/blog/image-08.jpg";
import img21 from "../images/blog/image-14.jpg";

const dataBlog = [
  {
    id: 1,
    img: img1,
    title: "From powder to powerhouse : How concentrates are quenching thirsts and boosting profits",
    cate: "Design",
    author: "Yannick",
    time: "2 days ago",
  },
  {
    id: 2,
    img: img2,
    title: "Three digital shopping trends to watch in 2024",
    cate: "Business",
    author: "Yannick",
    time: "2 days ago",
  },
  {
    id: 3,
    img: img3,
    title: "Global economic forecasts : 2024 outlook",
    cate: "Design",
    author: "Yannick",
    time: "2 days ago",
  },

  {
    id: 4,
    img: img4,
    cate: "Development",
    title: "How Does Writing Influence Your Personal Brand?",
    author: "Themeflat",
    time: "2 days ago",
    text: "The jobs report soundly beat expectations, with job gains broadly spread across the economy and about 60% higher…",
  },
  {
    id: 5,
    img: img5,
    cate: "Graphic Design",
    title: "How To Write Content About Your Photographs",
    author: "Themeflat",
    time: "2 days ago",
    text: "The jobs report soundly beat expectations, with job gains broadly spread across the economy and about 60% higher…",
  },
  {
    id: 6,
    img: img6,
    cate: "Content Marketing Design",
    title:
      "Where To Grow Your Business As A Photographer: Site Or Social Media?",
    author: "Themeflat",
    time: "2 days ago",
    text: "The jobs report soundly beat expectations, with job gains broadly spread across the economy and about 60% higher…",
  },
  {
    id: 7,
    img: img7,
    cate: "Business",
    title: "Caring Is The New Marketing",
    author: "Themeflat",
    time: "2 days ago",
    text: "The jobs report soundly beat expectations, with job gains broadly spread across the economy and about 60% higher…",
  },
  {
    id: 8,
    img: img8,
    cate: "Development",
    title: "Travelling As A Way Of Self-Discovery And Progress",
    author: "Themeflat",
    time: "2 days ago",
    text: "The jobs report soundly beat expectations, with job gains broadly spread across the economy and about 60% higher…",
  },
  {
    id: 9,
    img: img9,
    cate: "Graphic Design",
    title: "Where To Grow Your Business As A Photographer",
    author: "Themeflat",
    time: "2 days ago",
    text: "The jobs report soundly beat expectations, with job gains broadly spread across the economy and about 60% higher…",
  },
  {
    id: 10,
    img: img10,
    cate: "Graphic Design",
    title: "How To Choose The Right Customer",
    author: "Themeflat",
    time: "2 days ago",
    text: "The jobs report soundly beat expectations, with job gains broadly spread across the economy and about 60% higher…",
  },
  {
    id: 11,
    img: img11,
    cate: "Graphic Design",
    title: "Start A Blog To Reach Your Creative Peak",
    author: "Themeflat",
    time: "2 days ago",
    text: "The jobs report soundly beat expectations, with job gains broadly spread across the economy and about 60% higher…",
  },
  {
    id: 12,
    img: img12,
    cate: "Graphic Design",
    title: "Starting Your Traveling Blog With Vasco",
    author: "Themeflat",
    time: "2 days ago",
    text: "The jobs report soundly beat expectations, with job gains broadly spread across the economy and about 60% higher…",
  },

  {
    id: 13,
    img: img13,
    cate: "Development",
    title: "How to make the most of your virtual admissions interview",
    author: "Themeflat",
    time: "2 days ago",
  },
  {
    id: 14,
    img: img16,
    cate: "Development",
    title: "Jobtex is named a top HR product in G2’s 2022 Best Software Awards",
    author: "Themeflat",
    time: "2 days ago",
  },
  {
    id: 15,
    img: img15,
    cate: "Development",
    title: "5 tips to create an ATS-friendly resume for post-grads",
    author: "Themeflat",
    time: "2 days ago",
  },

  {
    id: 16,
    img: img14,
    cate: "Development",
    title: "Jobtex partners with SAP and is available via the SAP® Store",
    author: "Themeflat",
    time: "2 days ago",
  },
  {
    id: 17,
    img: img17,
    cate: "Development",
    title: "Jobtex is number one for ten consecutive quarters!",
    author: "Themeflat",
    time: "2 days ago",
  },
  {
    id: 18,
    img: img18,
    cate: "Development",
    title: "20 HR Podcasts for Human Resources Professionals",
    author: "Themeflat",
    time: "2 days ago",
  },
  {
    id: 19,
    img: img19,
    cate: "Development",
    title: "8 Steps You’re Missing Before Booking Your Demo",
    author: "Themeflat",
    time: "2 days ago",
  },
  {
    id: 20,
    img: img20,
    cate: "Development",
    title: "The Fight Against Academic Burnout",
    author: "Themeflat",
    time: "2 days ago",
  },
  {
    id: 21,
    img: img21,
    cate: "Development",
    title: "16 Must-Read Human Resource Books in 2022",
    author: "Themeflat",
    time: "2 days ago",
  },
];

export default dataBlog;
